module.exports = __webpack_public_path__ + "img/feel-good-stretches-leg-stretch.3d899aad.png";